import React from "react";
import { CATEGORIES } from "../../lib/utils-cynos";

const CategoryChips = ({ category, onChange }) => (
  <div className="no-scrollbar -mx-4 mb-4 flex gap-2 overflow-x-auto px-4 pb-1 md:mx-0 md:mb-6 md:flex-wrap md:px-0" data-testid="cat-chips">
    <CatChip active={category === "all"} onClick={() => onChange("all")} label="All" testid="chip-all" />
    {CATEGORIES.map((c) => (
      <CatChip key={c.slug} active={category === c.slug} onClick={() => onChange(c.slug)} label={c.label} testid={`chip-${c.slug}`} />
    ))}
  </div>
);

const CatChip = ({ active, onClick, label, testid }) => (
  <button
    onClick={onClick}
    type="button"
    className={`min-h-[40px] shrink-0 rounded-[8px] border px-4 py-2 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors md:min-h-[44px] md:text-xs md:tracking-[0.2em] ${
      active ? "border-cynos-red bg-cynos-red text-white" : "border-white/20 hover:border-white"
    }`}
    data-testid={testid}
  >
    {label}
  </button>
);

export default CategoryChips;
